import EmptyState from '../../../components/ui/EmptyState';

export default function AgentPerformanceView({ data }) {
  if (data.agents.length === 0) return <EmptyState title="No candidates with a referred agent in this range." />;

  return (
    <table className="min-w-full divide-y divide-gray-100 text-sm">
      <thead>
        <tr className="text-left text-xs uppercase tracking-wide text-gray-400">
          <th className="py-2">Agent</th>
          <th className="py-2">Registered</th>
          <th className="py-2">Hired</th>
          <th className="py-2">Rejected</th>
          <th className="py-2">Hire rate</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {data.agents.map((a) => (
          <tr key={a.agent}>
            <td className="py-2 text-gray-700">{a.agent}</td>
            <td className="py-2 text-gray-700">{a.registered}</td>
            <td className="py-2 text-gray-700">{a.hired}</td>
            <td className="py-2 text-gray-700">{a.rejected}</td>
            <td className="py-2 text-gray-700">{a.hire_rate_percent}%</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
